import React, { useCallback } from 'react';
import styles from './QueryResults.module.scss';
import { useSettings } from '../context/SettingsContext';
import { HEAP_EVENTS, HEAP_SCREENS, track } from '../../utils/analytics';

const AFF_CODE = 'ebnlsearchweb';

export interface Event {
    id: string;
    summary: string;
    url: string;
    imageUrl: string;
    title: string;
    dateTimeLocationRow: string;
    dateTime?: string;
    location?: string;
    priceRow: string;
}

export interface CardProps {
    event: Event;
    messagesSent: number;
}

interface FeedbackElementsProps {
    eventId: string;
}

const FeedbackElements = (props: FeedbackElementsProps) => {
    // Disabled for v0.
    // Leaving element for future expansion.
    const enabled = false;
    if (!enabled) {
        return null;
    }

    return (
        <div className={styles.feedback}>
            <p>up</p>
            <p>down</p>
        </div>
    );
};

const Card = (props: CardProps) => {
    const urlWithAffCode = `${props.event.url}?aff=${AFF_CODE}`;
    return (
        <div className={styles.cardRoot}>
            <div className={styles.explanation}>
                <p className={styles.explanationBody}>{props.event.summary}</p>
                {/* <div className={styles.explanationCTA}>Read description</div> */}
            </div>
            <a
                className={styles.link}
                href={urlWithAffCode}
                target="_blank"
                onClick={() => {
                    track({
                        eventName: HEAP_EVENTS.EventCardClick,
                        eventData: {
                            eventId: props.event.id,
                            url: props.event.url,
                            messagesSent: props.messagesSent,
                        },
                    });
                }}
            >
                <div className={styles.card}>
                    <div
                        className={styles.eventImage}
                        style={{ backgroundImage: `url(${props.event.imageUrl})` }}
                    ></div>
                    <div className={styles.details}>
                        <div className={styles.actions}>
                            {/* <div
                className={classNames([styles.eventShareCTA, styles.action])}
              >
                <ShareIcon width={20} height={20} />
              </div> */}
                            {/* <div className={classNames([styles.eventSaveCTA, styles.action])}>
                <HeartIcon width={20} height={20} />
              </div> */}
                        </div>
                        <p className={styles.eventDateTime}>{props.event.dateTime}</p>
                        <div className={styles.eventTitle}>{props.event.title}</div>
                        {props.event.dateTimeLocationRow}
                        <p className={styles.eventLocation}>{props.event.location}</p>
                        <div className={styles.eventPriceRow}>{props.event.priceRow}</div>
                    </div>
                </div>
            </a>
            <FeedbackElements eventId={props.event.id} />
        </div>
    );
};

interface QueryResultsProps {
    results: Array<CardProps['event']>;
    messagesSent: number;
}

export const QueryResults = (props: QueryResultsProps) => {
    const settings = useSettings();
    const [showAll, setShowAll] = React.useState(false);
    const hasMoreResults = props.results.length > 3;
    const displayedResults =
        settings.showMore && !showAll ? props.results.slice(0, 3) : props.results;

    const handleShowMore = useCallback(() => {
        setShowAll(true);
        track({
            eventName: HEAP_EVENTS.ShowMoreClick,
            eventData: {
                Screen: HEAP_SCREENS.CONCIERGE,
                resultCount: props.results.length,
                messagesSent: props.messagesSent,
            },
        });
    }, [setShowAll, props.results, props.messagesSent]);

    return (
        <div className={styles.results}>
            {displayedResults.map((event, index) => {
                return (
                    <Card key={`card-${index}`} event={event} messagesSent={props.messagesSent} />
                );
            })}
            {settings.showMore && hasMoreResults && !showAll && (
                <button className={styles.showMoreButton} onClick={handleShowMore}>
                    Show More
                </button>
            )}
        </div>
    );
};
